define('LNRS/Track/TrackLinks',[
    "jquery",
    "Track/DataLayerManager",
    "Utility/UrlHelper"
], function ($, dlmanager, urlHelper) {

    return function trackLinks() {
        var hostname = window.location.hostname;

        function trackExitLinks(ev) {
            // Don't track if this is an anchor generated by algolia components
            if ($(ev.target).is("[class^='ais-']")) {
                return;
            }

            // Don't track if this is an anchor that's not used for linking to another page
            var href = (this.getAttribute("href") || "").toLowerCase() ;
            if (!href || href.startsWith("#") || href.startsWith("mailto") || href.startsWith("javascript")) {
                return;
            }

            ev.preventDefault();

            var shouldTrack = true, $el = $(this), o = { site_events: {} };

            // 7.10.8 Sharing Via Email
            if ($el.hasClass("at-svc-email")) {
                o.site_events["email_share"] = "true";
                o["event_name"] = "share content";
            }
            // 7.10.7 Social Sharing
            else if ($el.hasClass("at-share-btn")) {
                o.site_events["social_share"] = "true";
                o["event_name"] = "share content";
                o["social_network"] = $el.children(".at4-visually-hidden").text().replace(/\s\s+/g, " ").replace("Share to ", "");
            }
            // 7.10.5 Change Regions
            else if (this.href.indexOf("geo=1") > 0 && $el.closest(".language-selector").length > 0) {
                o.site_events["change_region"] = "true";
                o["event_name"] = "switch region";
                o["region_site_url"] = this.href;
            }
            // 7.10.9 Download Content
            else if (this.hostname.indexOf(hostname) > -1 && this.pathname.indexOf("/-/media/") > -1) {
                o.site_events["download_file"] = "true";
                o["event_name"] = "download";
                o["download_name"] = this.href.split("/").pop();
                o["download_url"] = this.href;
            }
            // 7.10.6 Product Portal Links
            else if ($el.closest(".product-portal-container").length) {
                o.site_events["product_portal_link"] = "true";
                o["event_name"] = "product portal";
                o["portal_site_url"] = this.href;
                o["portal_link_text"] = $el.text().replace(/\s\s+/g, " ");
            }  
            // 7.10.4 Exit Links
            else if (this.hostname !== hostname) {
                o.site_events["exit_link"] = "true";
                o["event_name"] = "exit link";
                o["exit_link_url"] = this.href;
            }
            // Internal links
            else {
                var currentHref = window.location.href;
                if (href === currentHref.split('?')[0]) {
                    return;
                }
                else if (href.split("#")[0] === currentHref.split("#")[0]) {
                    window.location = this.href;
                } else {
                    shouldTrack = false;
                }
            }

            if (shouldTrack) {
                dlmanager.trackAnalytics(o);
            }

            // Check "open in new window/tab" key modifiers
            if (ev.shiftKey || ev.ctrlKey || ev.metaKey || ev.currentTarget.target === '_blank') {
                window.open(this.href, '_blank');
            } else {
                window.location = this.href;
            }
        }

        $(document).on("click", "a", trackExitLinks);

        //$(".social-sharing.site li").click(function () {
        //    var o = { site_events: {} };
        //    o.site_events["social_share"] = "true";
        //    o["event_name"] = "share content";
        //    o["social_network"] = $(this).find('.social-text').text().toLowerCase();
        //    o["Social_position"] = "global side";
        //    dlmanager.trackAnalytics(o);
        //});

        //$(".social-sharing.page li").click(function () {
        //    var o = { site_events: {} };
        //    o.site_events["social_share"] = "true";
        //    o["event_name"] = "share content";
        //    o["social_network"] = $(this).find('.social-text').text().toLowerCase();
        //    o["Social_position"] = "page body";
        //    dlmanager.trackAnalytics(o);
        //});
    };
});
